<template>
    <div id="syncAMISModal" class="modal" @click="onCloseClicked()" v-if="showAMISSync">
        <div class="modal-content" @click.stop="" style="height:auto;"
            :style="{ 'width': showUnits ? '400px' : '75%', 'max-height': showUnits ? '50%' : '75%' }">
            <div class="my-modal-header" v-show="!showProgress">
                <div style="padding-top: 6px;font-weight: 500;font-size: 22px;font-style: italic;">Sync Inspections</div>
                <span class="close fas fa-times" @click="onCloseClicked()"></span>
            </div>
            <div class="modal-body" style="padding:0;" v-show="showUnits && !showProgress">
                <div class="row-input">
                    <div style="font-size: 22px;text-decoration: underline;">Units</div>
                    <div class="secondary-btn" @click="selectAllUnits"> Select All</div>
                </div>
                <div v-for="unit in units" :key="unit.pltCode" style="display:flex;align-items: center;">
                    <input type="checkbox" :id="unit.pltCode + unit.pltName" v-model="unit.isSelected">
                    <label :for="unit.pltCode + unit.pltName">{{ unit.pltName }}</label>
                </div>
            </div>
            <div class="modal-body table-modal" style="padding:0;" v-show="!showUnits && !showProgress">
                <div v-if="!noDataToUpdate">
                    <div class="tab">                    
                        <button v-for="tab in tabs.filter(t => !!t.data.length)" :key="tab.name" class="tab-links" @click="openTab(tab)"
                            :class="{ 'selected-tab': tab.isSelected }">{{ tab.name }} ({{tab.data.length}})</button>
                    </div>

                    <div class="filters-section">
                        <div style="display: flex;column-gap: 10px;">
                            <div class="admin-btn" @click="showNotMatched = !showNotMatched" :class="{'selected-filter': showNotMatched}">Not Matched</div>
                            <div class="admin-btn" @click="showMatched = !showMatched" :class="{'selected-filter': showMatched}">Matched</div>
                        </div>
                        
                        <ColumnChooserButton></ColumnChooserButton>
                    </div>

                    <div v-for="t in tabs" :key="t.name">
                        <div v-show="(t.isSelected && !!t.data.length)" class="tab-content">
                            <!-- <AmisDataTable :show_matched="showMatched" :show_not_matched="showNotMatched" :type="t.id" :tags="t.data"></AmisDataTable> -->
                            <AdminInspectionTable :show_matched="showMatched" :show_not_matched="showNotMatched" :type="t.id" :tags="t.data"></AdminInspectionTable>
                        </div>
                    </div>

                    <ColumnChooserPopup v-if="showColumnChooserPopup"></ColumnChooserPopup>
                </div>

                <div v-else style="display:flex;">
                    <span class="no-updates">All AMIS Inspections are up to date.</span>
                </div>
            </div>
            <div class="modal-footer" v-if="showUnits && !showProgress" style="justify-content: end;">
                <div class="admin-btn" style="width: 100px;" @click="next()">Next</div>
            </div>
            <div class="modal-footer" v-if="!showUnits && !showProgress" style="justify-content: end;margin-top:15px">
                <div class="admin-btn admin-btn-secondary" style="width: 100px;" @click="back()">Back</div>
                <div class="admin-btn" style="width: 100px;" v-if="!noDataToUpdate" @click="generate()">Update</div>
            </div>
            <LoadingPopup v-if="showProgress" :show="showProgress" :text="progressText"
                style="position: relative;"></LoadingPopup>

        </div>
    </div>
</template>
    
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import { getAmisPlantList, getUpdatedAMISInspections, updateAMISTags, getAMISTags } from '@/utils/amisAPIs';
import $ from 'jquery';
import AdminInspectionTable from './admin-inspection-table.vue';
import ColumnChooserButton from '@/components/dashboard/column-chooser/column-chooser-button.vue';
import ColumnChooserPopup from '@/components/dashboard/column-chooser/column-chooser-popup.vue';
export default {
    name: 'SyncAMISPopup',
    components: {
    LoadingPopup: () => import('../../../../components/common/loadingPopup.vue'),
    AmisDataTable: () => import('./amisDataTable.vue'),
    AdminInspectionTable,
    ColumnChooserButton,
    ColumnChooserPopup
},
    data() {
        return {
            showUnits: true,
            showProgress: false,
            progressText: '',
            units: [],
            tabs: [
                { id:'newInspections', name: 'Added', data: [], isSelected: true },
                { id:'updatedInspections', name: 'Updated', data: [], isSelected: false },
                { id:'deletedInspections', name: 'Deleted', data: [], isSelected: false },
            ],
            showMatched: true,
            showNotMatched: true,
        }
    },
    methods: {
        openTab(tab) {
            this.tabs.forEach(t => t.isSelected = tab == t);
        },
        back() {
            this.showUnits = true;
        },
        onCloseClicked() {
            if (this.showProgress)
                return;
            this.$store.state.TAGS.showAdminSyncPopup = false;
            this.showColumnChooserPopup = false;
        },
        selectAllUnits(e) {
            if (this.units.length < 1) return;

            this.units.forEach(unit => unit.isSelected = true);
        },
        getUnits() {
            this.showUnits = true;
            this.showProgress = true;
            this.progressText = 'Fetching A-MIS Units...';
            getAmisPlantList().then(data => {
                data.forEach(o => o.isSelected = false);
                this.units = data
                this.showProgress = false;
            })
        },
        next() {
            this.progressText = 'Checking AMIS Inspections updates...';
            this.getTagsUpdates();
        },
        getTagsUpdates() {
            var selected = this.units.filter(o => o.isSelected);

            if (selected.length == 0) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please select a unit first.' })
                return
            }

            this.showProgress = true;
            
            getUpdatedAMISInspections(this.assetId, selected.map(u => u.pltCode))
            .then(data => {
                let { newInspections, updatedInspections, deletedInspections } = data;

                this.tabs[0].data = newInspections ?? [];
                this.tabs[1].data = updatedInspections ?? [];
                this.tabs[2].data = deletedInspections ?? [];

                let tab = this.tabs.find(t => !!t.data.length);

                this.tabs.forEach(t => t.isSelected = false);

                if (tab) tab.isSelected = true;

                this.showUnits = false;
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {                
                this.showProgress = false;
            });
        },
        generate() {
            this.progressText = 'Updating ...';
            this.showProgress = true;

            updateAMISTags(this.assetId, this.tagsUpdates).then((data) => {
                getAMISTags(0, 200).then(() => {
                    this.showProgress = false;
                    this.onCloseClicked();
                    this.$store.dispatch('showSuccessfulMessage', {
                        message: "AMIS Tags Updated Successfully", timeout: 2000
                    })
                });
            })
            .catch(error => {
                console.log(error);
                this.showProgress = false;
                this.$store.dispatch("alert_Forge", {
                    message: 'An error occurred, Please try again.'
                })
            });
        },
    },
    watch: {
        "showAMISSync": {
            handler:
                function (newValue, oldValue) {
                    $('.left-content').css('overflow-y', newValue ? 'hidden' : 'auto')
                    if (newValue)
                        document.getElementsByClassName('left-content').item(0).scrollTop = 0
                    if (newValue) {
                        this.getUnits()
                    }
                },
            deep: true
        },
    },
    computed: {
        showAMISSync() {
            return this.$store.state.TAGS.showAdminSyncPopup
        },
        noDataToUpdate() {
            return this.tabs.every(t => !t.data?.length );
        },
        assetId () {
            return this.$store.state.assetId;
        },
        tagsUpdates () {
            return this.tabs.reduce((t, c) => {
                t[c.id] = c.data;
                return t;
            }, {});
        },
        showColumnChooserPopup: {
            get() {
                return this.$store.getters.GET_SHOW_COLUMN_CHOOSER_POPUP;
            },
            set(value) {
                this.$store.commit('SET_SHOW_COLUMN_CHOOSER_POPUP', value);
            }
        },
    },
}
</script>
    
<style>
#syncAMISModal {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(1, 1, 1, .5);
}

.amis-title {
    font-size: 22px;
    text-decoration: underline;
}

.amis-tag-row {
    display: flex;
    align-items: center;
}

.amis-col {
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-size: 12px;
    box-sizing: border-box;
    border-right: 1px solid #d4d4d4;
    padding: 4px 0px;
}

.amis-col:last-child {
    border-right: none;
}

.my-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.my-modal-header i {
    color: var(--dark-primary-color);
    cursor: pointer;
}

.my-modal-header i:hover {
    color: var(--light-primary-color);
}

.my-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.my-modal-header span {
    font-size: 22px;
    color: var(--dark-primary-color);
    font-weight: 700;
}

.tab {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
}

.tab button {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #5e5e5e;
}

.tab button:hover {
    background-color: #dfdddd69;
    color: var(--primary-color);
}

.tab button.active {
    background-color: #ccc;
}

.tab-content {
    display: flex;
    overflow: auto;
    border: 1px solid #ccc;
    border-top: none;
    height: 100%;
}

.tab button.selected-tab {
    background-color: #dfdddd69;
    color: var(--primary-color);
}

.no-updates {
    font-size: 22px;
    text-align: center;
    width: 100%;
    color: var(--dark-primary-color);
    font-weight: 500;
    font-style: italic;
}

.filters-section {
    display: flex;
    -moz-column-gap: 5px;
    column-gap: 5px;
    margin: 10px 0px;
    justify-content: space-between;
    align-items: center;
}

.filters-section .admin-btn {
    margin: 0px;
    width: 100px;
    background: white;
    color: var(--primary-color);
    font-weight: 700;
    font-size: 12px;
    box-shadow: none;
    border-radius: 5px;
    border: 1px solid var(--primary-color);
    transition: all 0.05s ease-out 25ms;
}

.filters-section .admin-btn.selected-filter {
    color: white;
    background: var(--primary-color);
}
.filters-section .admin-btn:hover {
    color: #f1f1f1;
    background: #cb7fa5;
}

.table-modal.modal-body {
    overflow: hidden;
}

#syncAMISModal .column-chooser-popup {
    top: calc(50% - 225px);
    right: calc(50% - 125px);
}
</style>
